import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";

import InfinitePlanetMenu from "../components/InfinitePlanetMenu";
import "./ProjectsSpacePage.css";
import { planets } from "../data/planets";

export default function ProjectsSpacePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [initialPlanetId] = useState(() => {
    const fromState = location.state?.returnPlanetId;
    if (planets.some((planet) => planet.id === fromState)) return fromState;

    if (typeof window !== "undefined") {
      const fromStorage = window.sessionStorage.getItem(
        "projectsActivePlanetId",
      );
      if (planets.some((planet) => planet.id === fromStorage))
        return fromStorage;
    }

    return planets[0]?.id;
  });
  const [activePlanetId, setActivePlanetId] = useState(initialPlanetId);

  const activePlanet = useMemo(
    () => planets.find((planet) => planet.id === activePlanetId) || planets[0],
    [activePlanetId],
  );

  const handlePlanetClick = useCallback(
    (payload) => {
      if (!payload?.item?.id) return;
      if (typeof window !== "undefined") {
        window.sessionStorage.setItem(
          "projectsActivePlanetId",
          payload.item.id,
        );
      }
      navigate(`/projects/${payload.item.id}`, {
        state: {
          transition: {
            x: payload.center?.x ?? null,
            y: payload.center?.y ?? null,
            color: payload.item.color,
            name: payload.item.name || payload.item.id,
          },
        },
      });
    },
    [navigate],
  );

  const handleActivePlanetChange = useCallback((_, item) => {
    if (!item?.id) return;
    setActivePlanetId((prev) => (prev === item.id ? prev : item.id));
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!activePlanetId) return;
    window.sessionStorage.setItem("projectsActivePlanetId", activePlanetId);
  }, [activePlanetId]);

  return (
    <div className="projects-space">
      <header className="projects-space__header">
        <Link to="/" className="projects-space__logo">
          DYLAN CHEN ZHEN
        </Link>
        <nav className="projects-space__nav">
          <Link to="/lab" className="projects-space__nav-link">
            Lab
          </Link>
          <Link to="/about" className="projects-space__nav-link">
            About
          </Link>
        </nav>
      </header>

      <div className="projects-space__intro">
        <span className="projects-space__eyebrow">Projects</span>
        <h1 className="projects-space__title">Planet Archive</h1>
        <p className="projects-space__subtitle">
          Drag to orbit. Click a planet to open its chapter.
          {activePlanet?.name
            ? ` Currently orbiting: ${activePlanet.name}.`
            : ""}
        </p>
      </div>

      <div className="projects-space__menu">
        <InfinitePlanetMenu
          items={planets}
          scale={1.05}
          initialActiveItemId={initialPlanetId}
          onPlanetClick={handlePlanetClick}
          onActivePlanetChange={handleActivePlanetChange}
        />
      </div>
    </div>
  );
}
